import { render } from "./AddTalkModal.vue?vue&type=template&id=39cabcd5&scoped=true"
import script from "./AddTalkModal.vue?vue&type=script&lang=js"
export * from "./AddTalkModal.vue?vue&type=script&lang=js"

import "./AddTalkModal.vue?vue&type=style&index=0&id=39cabcd5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cabcd5"]])

export default __exports__